// extracted by mini-css-extract-plugin
export default {"Title":"Matting_Title__QTvEW","Controller":"Matting_Controller__vq9G7","Content":"Matting_Content__aHKLf","DragAndScale":"Matting_DragAndScale__shriZ","Tips":"Matting_Tips__-6RDj"};